import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/Login.vue'
import UpdatePwd from '@/views/UpdatePwd.vue'
import Layout from '@/views/Layout.vue'
import BookingManagement from '@/views/BookingManagement.vue'
import UserManagement from '@/views/UserManagement.vue'
import LeadManagement from '@/views/LeadManagement.vue'
import { getToken } from '@/utils/request'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/updatePwd',
    name: 'UpdatePwd',
    component: UpdatePwd,
    meta: { title: '重置密码' }
  },
  {
    path: '/home',
    name: 'Home',
    component: Layout,
    redirect: '/home/dashboard',
    meta: { title: '首页' },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '工作台' }
      },
      {
        path: 'booking',
        name: 'BookingManagement',
        component: BookingManagement,
        meta: { title: '预约单管理' }
      },
      {
        path: 'booking/detail',
        name: 'BookingDetail',
        component: () => import('@/views/BookingDetail.vue'),
        meta: { title: '预约单' }
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: UserManagement,
        meta: { title: '用户管理' }
      },
      {
        path: 'users/detail',
        name: 'UserDetail',
        component: () => import('@/views/UserDetail.vue'),
        meta: { title: '用户' }
      },
      {
        path: 'articles',
        name: 'LeadManagement',
        component: LeadManagement,
        meta: { title: '线索池管理' }
      },
      {
        path: 'articles/detail',
        name: 'LeadDetail',
        component: () => import('@/views/LeadDetail.vue'),
        meta: { title: '线索' }
      },
      {
        path: 'ride',
        name: 'RideManagement',
        component: () => import('@/views/RideManagement.vue'),
        meta: { title: '驾乘单管理' }
      },
      {
        path: 'ride/detail',
        name: 'RideDetail',
        component: () => import('@/views/RideDetail.vue'),
        meta: { title: '驾乘单详情' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫 - 鉴权 + 设置页面标题
const WHITE_LIST = ['/login', '/updatePwd']

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - 道上麦车`
  }

  const hasToken = getToken()

  if (hasToken) {
    // 已登录访问登录页时，重定向到首页
    if (to.path === '/login') {
      next('/home')
    } else {
      next()
    }
  } else {
    // 未登录：白名单放行，其余跳转登录页
    if (WHITE_LIST.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
